import { PermissionEnum } from '@shared/api/identity/enums/permission.enum';

const PERMISSION_BY_ROUTE = {
  '/leads': PermissionEnum.LeadView,
  '/leads/create': PermissionEnum.LeadCreate,
  '/leads/edit': PermissionEnum.LeadUpdate,
  '/leads/import-leads': [PermissionEnum.LeadCreate, PermissionEnum.LeadUpdate],
  '/companies': PermissionEnum.CompanyView,
  '/companies/create': PermissionEnum.CompanyCreate,
  '/companies/edit': PermissionEnum.CompanyUpdate,
  '/metadata/lead': PermissionEnum.MetadataLeadView,
  '/metadata/lead/create': PermissionEnum.MetadataLeadCreate,
  '/metadata/lead/edit': PermissionEnum.MetadataLeadUpdate,
  '/metadata/company': PermissionEnum.MetadataCompanyView,
  '/metadata/company/create': PermissionEnum.MetadataCompanyCreate,
  '/metadata/company/edit': PermissionEnum.MetadataCompanyUpdate,
  '/opportunities': PermissionEnum.OpportunityView,
  '/opportunities/opportunity-details': PermissionEnum.OpportunityView,
  '/opportunities/campaign/create': PermissionEnum.CampaignCreate,
  '/conversas': PermissionEnum.EncounterView,
  '/report': PermissionEnum.ReportDashboardView,
  '/users': PermissionEnum.UserView,
  '/users/create': PermissionEnum.UserCreate,
  '/users/edit': PermissionEnum.UserUpdate,
  '/roles': PermissionEnum.RoleView,
  '/roles/create': PermissionEnum.RoleCreate,
  '/roles/edit': PermissionEnum.RoleUpdate,
  '/roles/view': PermissionEnum.RoleView,
} as const satisfies Record<string, PermissionEnum | readonly PermissionEnum[]>;

type PermissionByRoute = typeof PERMISSION_BY_ROUTE;

export type GuardedRoute = keyof PermissionByRoute;

export type SinglePermissionRoute = { [TRoute in GuardedRoute]: PermissionByRoute[TRoute] extends PermissionEnum ? TRoute : never }[GuardedRoute];

export function permissionOfRoute(route: SinglePermissionRoute): PermissionEnum {
  return PERMISSION_BY_ROUTE[route];
}

export function permissionsOfRoute(route: GuardedRoute): readonly PermissionEnum[] {
  const declared: PermissionEnum | readonly PermissionEnum[] = PERMISSION_BY_ROUTE[route];

  return typeof declared === 'number' ? [declared] : declared;
}
